import { graphql, useStaticQuery } from 'gatsby';
import { LATEST_SLUG } from '@constants/global';

export type CanonicalProps = {
  canonicalPageCodename?: string;
  baseUrl?: string;
  urlSlug?: string;
  hasCanonicalToLatestVersion?: boolean;
};

const useCanonical = ({
  canonicalPageCodename,
  urlSlug,
  baseUrl,
  hasCanonicalToLatestVersion,
}: CanonicalProps) => {
  const { allKenticoLink, site } = useStaticQuery<Queries.PageLinksQuery>(graphql`
    query PageLinks {
      site {
        siteMetadata {
          siteUrl
        }
      }
      allKenticoLink {
        nodes {
          codename
          url
        }
      }
    }
  `);

  if (canonicalPageCodename) {
    const canonicalTargetUrl = allKenticoLink.nodes.find(
      (node) => node.codename === canonicalPageCodename || ''
    )?.url;
    return {
      canonicalUrl: canonicalTargetUrl
        ? `${site!.siteMetadata!.siteUrl}${canonicalTargetUrl}`
        : null,
    };
  }

  if (hasCanonicalToLatestVersion && baseUrl && urlSlug) {
    return {
      canonicalUrl: `${site!.siteMetadata!.siteUrl}${baseUrl?.replace(urlSlug, LATEST_SLUG)}`,
    };
  }

  return { canonicalUrl: null };
};

export default useCanonical;
